module.exports = __webpack_public_path__ + "static/media/enjoymusic-dark.d97ccee7.svg";